/* eslint react/jsx-filename-extension: 0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Autocomplete, Button, Form, Modal, Panel, WebRequest,
} from 'framework-ui-components';
import { SnackbarWrapper as SnackbarManager } from 'framework-ui-components/Components/Snackbar';

class ModaleCreaVoltura extends Component {
  constructor(props) {
    super(props);

    this.state = {
      avvisiVolture2: [],
      ComuneAgenziaVoltura: '',
      codiceUfficio: '',
      descrizioneUfficioRegistro: '',
    };
    this.scaricaVoltura = this.scaricaVoltura.bind(this);
  }

  componentDidMount() {
    const { idDichiarazione } = this.props;

    // stabilisce se la dichiarazione è compatibile con il formato 2.0
    // anche se le province sono tutte migrate al SIT, la chiamata
    // ci consente di visualizzare eventuali avvisi di incompatibilità
    // con il contenuto della dichiarazione
    WebRequest.get('Successioni/DichiarazioneCompatibileVolture20', { idDichiarazione })
      .then((DichiarazioneCompatibileVolture20Dto) => this.setState({
        avvisiVolture2: DichiarazioneCompatibileVolture20Dto.Avvisi,
      }))
      .catch();
  }

  scaricaVoltura(versione) {
    const { isFormValid, ComuneAgenziaVoltura, codiceUfficio } = this.state;
    const { idDichiarazione } = this.props;

    const url = `${window.config.urlSuccessioni}/DichiarazioneSuccessione/CreaVoltura/`
      + `?idDichiarazione=DichiarazioneSuccessione/${idDichiarazione.split('/')[1]
      }&comune=${encodeURIComponent(ComuneAgenziaVoltura)
      }&codiceUfficioRegistro=${encodeURIComponent(codiceUfficio)
      }&versione=${encodeURIComponent(versione)}`;

    if (isFormValid) {
      window.open(url);
    } else {
      SnackbarManager.notifyError('Compilare i campi richiesti');
    }
  }

  aggiornaUfficioRegistro(ufficio) {
    this.setState({
      codiceUfficio: ufficio.codiceUfficio,
      descrizioneUfficioRegistro: ufficio.descrizione,
    });
  }

  render() {
    const { onClose } = this.props;
    const { avvisiVolture2 } = this.state;

    return (
      <Modal show onClose={onClose}>
        <Modal.Header>Creazione file Voltura</Modal.Header>
        <Modal.Body>
          <Form
            onChange={(x) => this.setState(x)}
            stato={this.state}
            onValidationChange={(validity) => this.setState({ isFormValid: validity })}
          >
            <SelezioneUfficioRegistro onChange={(ufficio) => this.aggiornaUfficioRegistro(ufficio)} />
          </Form>
          {!!avvisiVolture2 && (<ElencoAvvisi avvisi={avvisiVolture2} />)}
        </Modal.Body>
        <Modal.Footer>
          <Button flat onClick={onClose}>Chiudi</Button>
          <ButtonScaricaVoltura callback={(v) => this.scaricaVoltura(v)} />
        </Modal.Footer>
      </Modal>
    );
  }
}

const ElencoAvvisi = ({ avvisi }) => (
  <div className="successioni">
    {avvisi.map((item, i) => <div><Panel alert className="volture">{item}</Panel></div>)}
  </div>
);

const ButtonScaricaVoltura = ({ callback }) => (<Button flat onClick={() => callback('2.0')}>Crea file Voltura 2.0</Button>);

const SelezioneUfficioRegistro = ({ onChange }) => (
  <div>
    <label>Indicare l&apos;Ufficio Registro presso il quale è stata registrata la dichiarazione di successione</label>
    <Autocomplete
      title="Ufficio Registro"
      name="descrizioneUfficioRegistro"
      url="/Successioni/RicercaUfficioRegistroVoltura"
      validations={['required']}
      renderProperty="descrizione"
      onChange={(ufficio) => onChange(ufficio)}
    />
  </div>
);

ModaleCreaVoltura.propTypes = {
  idDichiarazione: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};

ButtonScaricaVoltura.propTypes = {
  callback: PropTypes.func.isRequired,
};

SelezioneUfficioRegistro.propTypes = {
  onChange: PropTypes.func.isRequired,
};

ElencoAvvisi.propTypes = {
  avvisi: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ModaleCreaVoltura;
